var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex flex-wrap date-range justify-space-between pb-2" },
    [
      _c("div", {}, [
        _c("label", { staticClass: "control-label" }, [
          _vm._v("Days of the week"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex flex-wrap justify-center" },
          _vm._l(_vm.weekdayOptions, function (day) {
            return _c("div", { staticClass: "checkbox" }, [
              _c("input", {
                attrs: { type: "checkbox", name: "day" },
                domProps: { value: day.value, checked: _vm.dayIsToggled(day) },
                on: {
                  change: function ($event) {
                    return _vm.toggleDay(day)
                  },
                },
              }),
              _vm._v(" " + _vm._s(day.text) + "\n            "),
            ])
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }